
import { useEffect } from "react";
import { AuthContext } from "./AuthContext";
import { useOptimizedAuth } from "./hooks/useOptimizedAuth";
import { ProfileErrorAlert } from "./ProfileErrorAlert";
import { LoadingState } from "@/components/admin/LoadingState";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  console.log('Optimized AuthProvider initializing');
  
  const {
    user,
    session,
    profile,
    organization,
    loading,
    profileLoaded,
    signOut
  } = useOptimizedAuth();

  // Optimized debug logging - only in development mode
  useEffect(() => {
    if (!import.meta.env.DEV) return;
    
    const interval = setInterval(() => {
      if (loading || !profileLoaded) {
        console.log('Auth loading state:', { 
          hasUser: !!user, 
          loading, 
          profileLoaded,
          hasProfile: !!profile,
          hasOrganization: !!organization
        });
      }
    }, 10000); // Log every 10 seconds and only when loading

    return () => clearInterval(interval);
  }, [user, loading, profileLoaded, profile, organization]);

  const contextValue = {
    session,
    user,
    isLoading: loading,
    loading,
    signOut,
    organization,
    profile,
    profileLoaded,
  };

  // Show loading state only when actually initializing
  if (loading && !user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingState />
      </div>
    );
  }

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export { useAuth } from "./useAuth";
